import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const TPiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='130'
        height='125'
        viewBox='0 0 130 125'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M8.37011 28.1943C3.95184 28.1943 0.370117 24.6126 0.370117 20.1943L0.370116 8.05225C0.370116 3.63397 3.95184 0.0522459 8.37012 0.0522457L121.551 0.0522408C125.969 0.0522406 129.551 3.63396 129.551 8.05224L129.551 20.1943C129.551 24.6126 125.969 28.1943 121.551 28.1943L8.37011 28.1943Z' />
      </svg>
    </div>
  );
});

TPiece.displayName = 'TPiece';

export default motion.create(TPiece);
